import type {
  CreateInvoiceTemplateRequest,
  InvoiceTemplateResponse,
  UpdateInvoiceTemplateRequest,
} from '@/shared/api';

export interface InvoiceTemplateForm {
  name: string;
  isPrimary: boolean;
  companyName: string;
  billingStreet: string;
  billingPostalCode: string;
  billingCity: string;
  billingCountry: string;
  taxNumber: string;
  vatId: string;
  iban: string;
  bic: string;
  bankName: string;
  contactEmail: string;
  contactPhone: string;
  paymentTermDays: string;
}

export function initialInvoiceTemplateForm(
  template: InvoiceTemplateResponse | null,
): InvoiceTemplateForm {
  return {
    name: template?.name ?? '',
    isPrimary: template?.isPrimary ?? false,
    companyName: template?.companyName ?? '',
    billingStreet: template?.billingStreet ?? '',
    billingPostalCode: template?.billingPostalCode ?? '',
    billingCity: template?.billingCity ?? '',
    billingCountry: template?.billingCountry ?? '',
    taxNumber: template?.taxNumber ?? '',
    vatId: template?.vatId ?? '',
    iban: template?.iban ?? '',
    bic: template?.bic ?? '',
    bankName: template?.bankName ?? '',
    contactEmail: template?.contactEmail ?? '',
    contactPhone: template?.contactPhone ?? '',
    paymentTermDays: template?.paymentTermDays != null ? String(template.paymentTermDays) : '',
  };
}

/**
 * Leere Felder werden `null`, nicht `''`.
 *
 * <p>Beim Zahlungsziel ist das mehr als Kosmetik: `Number('')` wäre 0 und damit eine Fälligkeit
 * am Ausstellungstag — leer heisst „kein Zahlungsziel hinterlegt".</p>
 */
function sharedFields(form: InvoiceTemplateForm) {
  return {
    companyName: form.companyName || null,
    billingStreet: form.billingStreet || null,
    billingPostalCode: form.billingPostalCode || null,
    billingCity: form.billingCity || null,
    billingCountry: form.billingCountry || null,
    taxNumber: form.taxNumber || null,
    vatId: form.vatId || null,
    iban: form.iban || null,
    bic: form.bic || null,
    bankName: form.bankName || null,
    contactEmail: form.contactEmail || null,
    contactPhone: form.contactPhone || null,
    paymentTermDays: form.paymentTermDays.trim() ? Number(form.paymentTermDays) : null,
  };
}

export function toUpdateRequest(form: InvoiceTemplateForm): UpdateInvoiceTemplateRequest {
  return { name: form.name, ...sharedFields(form) };
}

export function toCreateRequest(form: InvoiceTemplateForm): CreateInvoiceTemplateRequest {
  return { name: form.name, isPrimary: form.isPrimary, ...sharedFields(form) };
}
